export class Employee {
  constructor({
    id = 0,
    dealerID = 0,
    firstName = null,
    lastName = null,
    email = null,
    authorityLevel = null,
    jobTitle = null,
    loginStatus = null,
    contactNumber = null
  } = {}) {
    this.id = id;
    this.dealerID = dealerID;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.authorityLevel = authorityLevel;
    this.jobTitle = jobTitle;
    this.loginStatus = loginStatus;
    this.contactNumber = contactNumber;
  }
}
